module.exports = window.SmartfireJSBlockEngine;